/* @flow */

import { transparentize } from 'polished';

import { successColor, errorColor } from '@e180/ui/lib/token/color';
import { tablet, lap } from '@e180/ui/lib/token/mediaQuery';
import { white, mediumGrey } from '@e180/ui/lib/token/palette';

export default {
  root: {
    display: 'flex',
  },
  'root-darkBg': {},
  text: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    minWidth: 0,
    marginLeft: '0.5em',

    lineHeight: 1.2,

    '$root-darkBg &': {
      WebkitFontSmoothing: 'antialiased',
    },
  },
  'text-withIcon': {
    maxWidth: 'calc(100% - 110px)',

    [tablet]: {
      maxWidth: 'calc(100% - 120px)',
    },

    [lap]: {
      maxWidth: 'calc(100% - 140px)',
    },
  },
  name: {
    fontSize: 15,
    fontWeight: 500,

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    '$root-darkBg &': {
      color: white,
    },
  },
  'name-checkedIn': {
    color: successColor,
  },
  'name-notCheckedIn': {
    color: errorColor,
  },
  title: {
    color: mediumGrey,

    fontSize: 13,
    fontStyle: 'italic',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    '$root-darkBg &': {
      color: transparentize(0.5, white),
    },
  },
};
